<template>
  <!--主体部分-->
  <div class="w-body policyDate view-container">
    <van-popup
      class="policyProp"
      v-model="show"
      closeable
      round
      position="bottom"
    >
      <div class="top">保障责任</div>
      <div class="popupBox">
        <div class="popupDesc">
          <van-icon
            name="warning-o"
          />以下内容仅供参考，完整保障责任请以保险合同为准。
        </div>
        <van-tabs
          v-model="insureIndex"
          class="insurers"
          :swipe-threshold="1"
          v-if="rights.length > 1"
        >
          <van-tab
            v-for="(item, i) in rights"
            :key="i"
            :title="item.rightList[0].customerName"
          ></van-tab>
        </van-tabs>
        <div class="bzInfo">
          <div class="bzitem" v-if="rights.length > 0">
            <van-collapse accordion v-model="activeNames">
              <van-collapse-item
                v-for="(itemx, m) in rights[insureIndex].rightList"
                :key="m"
                :name="m"
              >
                <template #title>
                  <div>
                    <span class="left" v-html="itemx.rightName"></span
                    ><span class="right">{{ itemx.rightValue }}</span>
                  </div>
                </template>
                <pre v-html="itemx.describe"></pre>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </div>
    </van-popup>

    <div class="listInfoBox">
      <div class="policy-04-list order-detail">
        <div>
          <p class="title">{{ policyDate.insuranceProductName }}</p>
          <p v-if="company">由{{ company.name }}承保</p>
          <p v-if="policyDate.id && policyDate.id.length > 5">
            订单号:{{ policyDate.id }}
            <span @click="copyData(policyDate.id)" class="btn-copy">复制</span>
          </p>
        </div>
        <img
          v-if="orderStatusImg(policyDate)"
          class="status-logo"
          :src="orderStatusImg(policyDate)"
        />
      </div>
      <div class="policy-04-list pay-detail">
        <div>
          <p
            v-if="orderStatusTxt(policyDate)"
            class="title"
            v-html="orderStatusTxt(policyDate)"
          ></p>
          <div class="flex-end">
            <span
              v-if="
                policyDate.effectiveStatus == 0 ||
                  policyDate.effectiveStatus == -4
              "
              @click="continuePay"
              class="btn-pay"
            >
              继续支付
            </span>
            <span class="btn-pay"
                    v-else-if="policyDate.qualityCheckStatus == 0"
                    @click="newPay(policyDate)">
              质检回复
            </span>
            <span
              class="btn-pay"
              v-else-if="policyDate.doubleRecordStatus != null"
              @click="newPay(policyDate)"
            >
              {{ doubleBtnTxt(policyDate) }}
            </span>
            <span
              v-else-if="
                policyDate.effectiveStatus == -3 ||
                  policyDate.effectiveStatus == -8
              "
              class="btn-pay"
              @click="filedFn(policyDate)"
            >
              重新投保
            </span>
            <span
              v-else-if="policyDate.effectiveStatus == -2"
              class="btn-pay"
              @click="filedFn(policyDate)"
            >
              继续投保
            </span>
            <span
              v-else-if="policyDate.effectiveStatus == 6"
              class="btn-pay"
              @click="newPay(policyDate)"
            >
              继续投保
            </span>
            <span
              v-else-if="policyDate.effectiveStatus == 7"
              @click="continuePay"
              class="btn-pay"
            >
              继续投保
            </span>
            <template v-else-if="policyDate.effectiveStatus == 99">
              <span
                class="btn-pay"
                v-if="policyDate.curStatus == 5 && policyDate.curUrl"
                @click="redUrl"
              >
                继续支付
              </span>
              <span
                class="btn-pay"
                v-else-if="
                  (policyDate.curStep == 'NPQ' ||
                    policyDate.curStep == 'NQS') &&
                    policyDate.curUrl
                "
                @click="redUrl"
              >
                补充资料
              </span>
              <span
                class="btn-pay"
                v-else-if="policyDate.curStep == 'POI' && policyDate.curUrl"
                @click="redUrl"
              >
                修改资料
              </span>
              <span
                class="btn-pay"
                v-else-if="policyDate.curStep == 'IMC' && policyDate.curUrl"
                @click="redUrl"
              >
                结论确认
              </span>
              <span
                @click="goDetail"
                v-else-if="policyDate.effectiveStatus == 99"
                class="btn-pay"
                >查看详情</span
              >
            </template>
          </div>
        </div>
      </div>
      <div class="policy-04-list">
        <dl class="dlBox">
          <dt class="dlheader">
            <span class="item-title">订单详情</span>
            <span @click="showProp" class="c-o"
              >保障责任<van-icon name="arrow"
            /></span>
          </dt>
          <dd>
            <ul class="ulListBox">
              <!-- 保障额度 -->
              <li
                class="first-design-color"
                v-if="
                  policyDate.guaranteeLimit &&
                    policyDate.guaranteeLimit != 0 &&
                    policyDate.guaranteeLimit != '0.00'
                "
              >
                <span>基本保额</span>
                <span class="total">{{ policyDate | guaranteeLimit }}</span>
              </li>
              <li>
                <span>交费期间</span>
                <span class="total">{{ policyDate | paymentType }}</span>
              </li>
              <li>
                <span>投保时间</span>
                <span class="timer">
                  {{policyDate.createTime}}
                </span>
              </li>
              <li>
                <span>犹豫期</span>
                <span class="timer" v-if="policyDate.hesitatePeriod">
                  {{policyDate.hesitatePeriod}}天
                </span>
                <span class="timer" v-else>
                  无
                </span>
              </li>
              <!-- 保障期限 -->
              <template
                v-if="
                  policyDate.effectiveStatus != '-2' &&
                    policyDate.effectiveStatus != '-3'
                "
              >
                <li
                  v-if="
                    policyDate.guaranteeStartTime && policyDate.guaranteeEndTime
                  "
                >
                  <span>保险期限</span>
                  <span class="timer">
                    {{ policyDate.guaranteeStartTime | timeNum(10) }}至
                    <!-- {{
                      policyDate.guaranteeType == "A" &&
                      policyDate.guaranteeTerm == "106"
                        ? "终身"
                        : policyDate.guaranteeEndTime | timeNum(10)
                    }} -->
                    {{ policyDate | guaranteeFilter }}
                  </span>
                </li>
                <li>
                  <span>保费</span>
                  <span class="timer">
                    ¥{{
                      policyDate.actualPremium
                        ? policyDate.actualPremium
                        : policyDate.premium
                    }}
                  </span>
                </li>
              </template>
            </ul>
          </dd>
        </dl>
      </div>
      <div class="policy-04-list p-t-40">
        <div class="fwBottom">
          <div class="left">
            <a href="https://wtsbx.qiyukf.com/client?k=59ed88a4552beb1d89cb502bb4885dd6&wp=1&robotShuntSwitch=0&gid=484878140&language=zh-cn&templateId=6674361">
              <img src="@static/images/personal/p9.png" alt="" /><span
                >在线客服</span
              >
            </a>
          </div>
          <div class="right">
            <a href="tel://400-9955-788">
              <img src="@static/images/personal/p10.png" alt="" /><span
                >客服热线（7×24小时）</span
              >
            </a>
          </div>
        </div>
      </div>
      <div class="policy-04-list">
        <dl class="dlBox dlBoxDown1">
          <dt class="dlheader">
            <!-- 投保人信息 -->
            <span class="item-title">投保人信息</span>
          </dt>
          <dd>
            <ul class="ulListBox">
              <!-- 投保人姓名 -->
              <li v-if="policyDate.policyholderName" class="first-design-color">
                <span>投保人姓名</span>
                <span class="IDInfo">{{ policyDate.policyholderName }}</span>
              </li>
              <!-- 证件类型 -->
              <li>
                <span>证件类型</span>
                <span class="IDType">{{
                  policyDate.policyholderIdentifyType | identifyType
                }}</span>
              </li>
              <!-- 证件号码 -->
              <li v-if="policyDate.policyholderIdentifyNumber1">
                <span>证件号码</span>
                <span class="IDNumber">{{
                  policyDate.policyholderIdentifyNumber1
                }}</span>
              </li>
              <!-- <li v-if="policyDate.policyholderMobile2 !=''">手机号码：<span class="cellPhone">{{policyDate.policyholderMobile2}}</span></li> -->
              <li v-if="policyDate.policyholderEmail">
                <span>电子邮箱</span>
                <span class="Email ios-x">{{
                  policyDate.policyholderEmail
                }}</span>
              </li>
            </ul>
          </dd>
        </dl>
      </div>
      <!-- 被保险人信息 -->
      <div class="policy-04-list" id="insures">
        <template v-if="!insureder">
          <!-- 单被保险人 -->
          <dl class="dlBox dlBoxDown2">
            <dt class="dlheader">
              <span class="item-title">被保险人信息</span>
            </dt>
            <dd>
              <ul class="ulListBox">
                <!-- 被保险人姓名 -->
                <li
                  class="first-design-color"
                  v-if="policyDate.insuranceRelationship != 1"
                >
                  <span>被保险人姓名</span>
                  <span class="customerName">{{
                    policyDate.insurederName
                  }}</span>
                </li>
                <!-- 与投保人关系 -->
                <li>
                  <span>与投保人关系</span>
                  <span class="IDInfo">{{
                    policyDate.insuranceRelationship | insuranceRelationship
                  }}</span>
                </li>
                <template v-if="policyDate.insuranceRelationship != 1">
                  <!-- 证件类型 -->
                  <li>
                    <span>证件类型</span>
                    <span class="IDType">{{
                      policyDate.insurederIdentifyType | identifyType
                    }}</span>
                  </li>
                  <!-- 证件号码 -->
                  <li v-if="policyDate.insurederIdentifyNumber1">
                    <span>证件号码</span>
                    <span class="IDNumber">{{
                      policyDate.insurederIdentifyNumber1
                    }}</span>
                  </li>
                  <!-- 电子邮箱 -->
                  <li v-if="policyDate.insurederEmail">
                    <span>电子邮箱</span>
                    <span class="Email ios-x">{{
                      policyDate.insurederEmail
                    }}</span>
                  </li>
                </template>
              </ul>
            </dd>
          </dl>
        </template>
        <!-- 多被保险人 -->
        <template v-else>
          <dl class="dlBox dlBoxDown2">
            <dt class="dlheader">
              <span class="item-title"
                >被保险人信息（共{{ insureder.length }}人）</span
              >
            </dt>
            <dd v-for="(item, i) in insureder">
              <ul class="ulListBox">
                <li class="first-design-color">
                  <span>被保险人姓名</span>
                  <span class="customerName">{{ item.insurederName }}</span>
                </li>
                <li v-if="item.insuranceRelationship">
                  <span>与投保人关系</span>
                  <span class="IDInfo">{{
                    item.insuranceRelationship | insuranceRelationship
                  }}</span>
                </li>
                <li v-if="item.insurederIdentifyType">
                  <span>证件类型</span>
                  <span class="IDType">{{
                    item.insurederIdentifyType | identifyType
                  }}</span>
                </li>
                <li v-if="item.insurederIdentifyNumber1">
                  <span>证件号码</span>
                  <span class="IDNumber">{{
                    item.insurederIdentifyNumber1
                  }}</span>
                </li>
              </ul>
            </dd>
          </dl>
        </template>
      </div>
      <!-- 收益人信息 -->
      <div class="policy-04-list" id="beneficiarys">
        <template v-if="!beneficiary">
          <dl class="dlBox dlBoxDown3">
            <dt class="dlheader">
              <span class="item-title">受益人信息</span>
            </dt>
            <dd>
              <ul class="ulListBox">
                <li>
                  <span>受益人</span>
                  <span class="IDInfo" v-if="policyDate.beneficiaryType == 1" >法定受益人</span>
                  <span class="IDInfo" v-if="policyDate.beneficiaryType == 3" >被保险人</span>
                </li>
              </ul>
            </dd>
          </dl>
        </template>
        <template v-else>
          <dl class="dlBox dlBoxDown3">
            <dt class="dlheader">
              <span class="item-title"
                >受益人信息（共{{ beneficiary.length }}人）</span
              >
            </dt>
            <dd v-for="(item, i) in beneficiary">
              <ul class="ulListBox">
                <li class="first-design-color">
                  <span>受益人姓名</span>
                  <span class="IDInfo">{{ item.name }}</span>
                </li>
                <li>
                  <span>受益人</span>
                  <span class="IDInfo">指定受益人</span>
                </li>
                <li>
                  <span>与被保险人关系</span>
                  <span class="IDInfo">{{
                    item.insuranceRelationship | insuranceRelationship
                  }}</span>
                </li>
                <li>
                  <span>受益比例</span>
                  <span class="IDInfo">{{ item.percent }}%</span>
                </li>
                <li v-if="item.beneRank">
                  <span>受益人顺位</span>
                  <span class="IDInfo">第{{ item.beneRank }}顺位</span>
                </li>
                <li>
                  <span>证件号码</span>
                  <span class="IDInfo">{{ item.identifyNumber1 }}</span>
                </li>
              </ul>
            </dd>
          </dl>
        </template>
      </div>
      <div class="policy-04-list" v-if="bankCard">
        <dl class="dlBox dlBoxDown3">
          <dt class="dlheader">
            <span class="item-title">续期账户</span>
          </dt>
          <dd>
            <ul class="ulListBox">
              <li class="first-design-color">
                <span>开户行</span>
                <span class="customerName">{{ bankCard.bankName }}</span>
              </li>
              <li>
                <span>账户号码</span>
                <span class="IDInfo">{{ bankCard.bankAccNoMask }}</span>
              </li>
              <li v-if="bankCard.bankArea">
                <span>开户行地区</span>
                <span class="IDInfo">{{ bankCard.bankArea }}</span>
              </li>
            </ul>
          </dd>
        </dl>
      </div>
      <div class="policy-04-list" v-if="company">
        <dl class="dlBox dlBoxDown3">
          <dt class="dlheader">
            <span class="item-title">保险公司</span>
            <img class="company-logo" :src="company.logo" alt="" />
          </dt>
          <dd>
            <ul class="ulListBox">
              <li>
                <span>承保公司</span>
                <span class="IDInfo">{{ company.name }}</span>
              </li>
              <li class="first-design-color">
                <span>客服电话</span>
                <span class="customerName">{{ company.tellPhone }}</span>
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import filter from "@/api/filter.js"; //公共过滤器
import loading from "@/components/commons/loading";
import newProcess from "@static/js/process_products2.esm.min.js";
var vm = null;
export default {
  data() {
    return {
      activeNames: [],
      //加载开关
      loaded: false,
      //保单数据
      policyDate: {},
      orderId: "",
      //被保险人
      insureder: null,
      // 受益人
      beneficiary: null,
      // 附加险
      additionalList: null,
      // 账户价值
      policyValue: null,
      //续期账户
      bankCard: null,
      //承保公司
      company: null,
      //保障权益显示开关
      interestHide: false,
      bzqyType: [],
      show: false,
      insureIndex: 0,
      rights: [], //保障责任
    };
  },
  components: {
    "app-loading": loading,
  },
  filters: {
    guaranteeFilter(policyDate) {
      if(policyDate.guaranteeEndTime == '终身' || policyDate.guaranteeEndTime == '2888-01-01'){
        return '终身'
      }else {
        return filter.timeNum(policyDate.guaranteeEndTime, 10)
      }
    }
  },
  watch: {
    insureIndex(newVal) {
      if (newVal) {
        this.activeNames = [];
      }
    },
  },
  created() {
    vm = this;
    this.orderId = this.$route.params.id; //订单ID
    if (!this.$units.isLogin(this)) {
      return;
    }
    if (this.$route.query.new) {
      this.policyDateNew();
    } else {
      this.getPolicyDate();
    }
  },
  mounted() {},
  methods: {
    showProp() {
      this.insureIndex = 0;
      vm.show = true;
    },
    redUrl() {
      window.location.href = this.policyDate.curUrl;
    },
    doubleBtnTxt(item) {
      let btn = "查看详情";
      if (item.doubleRecordStatus != 0 && item.effectiveStatus == 6) {
        btn = "继续投保";
      } else if (item.doubleRecordStatus != 0 && item.effectiveStatus == 0) {
        btn = "继续支付";
      }
      return btn;
    },
    goDetail() {
      if (
        this.policyDate.showNewManualProcess == 1 ||
        this.policyDate.insureUniqueId
      ) {
        this.$router.push({
          path: "/m/personal/intellOrderInfo",
          query: { id: this.policyDate.insureUniqueId },
        });
        return;
      }
      this.$router.push({
        path: "/m/personal/intellOrderDetail",
        query: { orderId: this.policyDate.id },
      });
    },
    //重新填写
    filedFn(policyDate) {
      if (policyDate.insureUniqueId) {
        let url = `/m/product/writeInform?key=${policyDate.insureUniqueId}`;
        if (policyDate.effectiveStatus == -3) url += `&reWrite=true`;
        window.location.href = url;
        return;
      }
      //订单跳转处理
      if (policyDate.process.orderPage == 0) {
        window.location.href =
          window.location.origin +
          "/market/writeInform.html?policyId=" +
          policyDate.id;
      } else if (policyDate.process.orderPage == 1) {
        window.location.href =
          window.location.origin +
          "/market/writeInform-moreinsure.html?policyId=" +
          policyDate.id;
      } else if (policyDate.process.orderPage == 2) {
        window.location.href =
          window.location.origin +
          "/market/writeInform-3.html?policyId=" +
          policyDate.id;
      }
    },
    orderStatusTxt(item) {
      return filter.orderStatusTxt(item, 2);
    },
    orderStatusImg(item) {
      return filter.orderStatusImg(item);
    },
    // 新产品库继续支付
    newPay(data) {
      this.$http({
        url: "/insure/orders/proceed",
        type: "get",
        data: {
          insureUniqueId: data.insureUniqueId,
        },
      })
        .then((r) => {
          let step = r.data.step;
          if (
            r.data.step === "LOP" ||
            r.data.step === "SIC" ||
            r.data.step === "SHC" ||
            r.data.step === "FIC" ||
            r.data.step === "FHC"
          ) {
            // 外链支付
            location.href = r.data.payUrl;
            return;
          }
          let route = newProcess.getProcess(step);
          sessionStorage.reuseWriteInform = "";
          location.href = "/m" + route.url + "?key=" + r.data.insureUniqueId;
        })
        .catch((err) => {});
    },
    // 调用浏览器复制功能
    copyData(val) {
      var oInput = document.createElement("input");
      oInput.value = val;
      oInput.readOnly = true;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      vm.$notice.msg("复制成功");
    },
    //重新支付
    continuePay() {
      let policyDate = this.policyDate;
      if (policyDate.insureUniqueId) return this.newPay(policyDate);
      if (policyDate.faceResult == "0") {
        window.location.href =
          "/m/market/insurer-confirm-video.html?orderId=" + policyDate.id;
        return;
      }
      var productProcess = policyDate.process;
      sessionStorage.setItem("productProcess", JSON.stringify(productProcess));
      let payType = productProcess.payType;
      if (payType == 4 || payType == 8) {
        window.location.href = policyDate.checkResultJson.payUrl;
        return;
      }
      if (payType == 1) {
        window.location.href =
          window.location.origin + "/market/pay.html?policyId=" + policyDate.id;
      } else if (payType == 3) {
        if (productProcess.code.idCode == "945102593176518656") {
          window.location.href =
            window.location.origin +
            "/market/payMethod-02.html?policyId=" +
            policyDate.id;
          return;
        }
        window.location.href =
          window.location.origin +
          "/market/payMethod.html?policyId=" +
          policyDate.id;
      } else if (payType == 5) {
        window.location.href =
          window.location.origin +
          "/market/payMethod-2.0.html?policyId=" +
          policyDate.id;
      } else if (payType == 6) {
        window.location.href =
          window.location.origin +
          "/market/payMethod-3.0.html?policyId=" +
          policyDate.id; //跳转银行支付
      } else if (payType == 7) {
        window.location.href =
          window.location.origin +
          "/market/payMethod-4.0.html?policyId=" +
          policyDate.id; //银行支付-手机验证码
      } else if (payType == 9) {
        window.location.href =
          window.location.origin +
          "/market/payMethod-5.0.html?policyId=" +
          policyDate.id; //银行支付-手机验证码
      } else if (payType == 10) {
        window.location.href =
          window.location.origin +
          "/market/payMethod-6.0.html?policyId=" +
          policyDate.id; //银行支付-手机验证码
      }
    },
    //   新产品中心数据
    policyDateNew() {
      this.$http({
        url: "/insure/orders/detail",
        type: "get",
        data: {
          id: this.orderId,
        },
      })
        .then((data) => {
          vm.$nextTick(() => {
            vm.loaded = true;
            // 保单信息
            vm.policyDate = data.data.data;
            //判断保障权益是否存在
            // vm.protectRight();
            // 更多数据信息处理
            vm.insureChange(data);
          });
        })
        .catch((err) => {});
    },
    getPolicyDate() {
      // 取到路由带过来的参数
      this.$http({
        url: "/policy/order/api/orderDetail",
        contentType: "from",
        data: {
          orderId: this.orderId,
        },
      })
        .then((data) => {
          vm.$nextTick(() => {
            vm.loaded = true;
            // 保单信息
            vm.policyDate = data.data.data;
            //判断保障权益是否存在
            // vm.protectRight();
            // 更多数据信息处理
            vm.insureChange(data);
          });
        })
        .catch((err) => {});
    },
    /**更多数据信息处理 */
    insureChange(data) {
      //账户价值
      if (data.data.policyValue) this.policyValue = data.data.policyValue;
      //是否有多被保险人
      if (data.data.insureder) {
        this.moreInsureChange(data.data.insureder);
      }
      //是否有收益人
      if (data.data.beneficiary) this.beneficiary = data.data.beneficiary;
      //是否存在附加险
      if (data.data.additionalList)
        this.additionalList = data.data.additionalList;
      //更多被保险人信息
      // 是否存在续期账户信息
      if (data.data.bankCard) this.bankCard = data.data.bankCard;
      //是否存在承保公司
      if (data.data.company) this.company = data.data.company;
      if (data.data.rights){
        this.rights = data.data.rights;
        if(this.insureder) {
          let name = this.insureder[0].insurederName;
          let index;
          this.rights.forEach((item,i)=>{
            if(item.rightList[0].customerName == name) {
              index=i;
            }
          });
          let item = this.rights.splice(index,1)[0];
          this.rights.unshift(item);
        }
      } 
    },
    //更多被保险人信息
    moreInsureChange(insureder) {
      var datas = this.policyDate;
      if (insureder) {
        var newDatr = {
          insurederName: datas.insurederName,
          insurederIdentifyType: datas.insurederIdentifyType,
          insurederIdentifyNumber: datas.insurederIdentifyNumber,
          insurederIdentifyNumber1: datas.insurederIdentifyNumber1,
          insurederMobile: datas.insurederMobile,
          insuranceRelationship: datas.insuranceRelationship,
        };
        insureder.unshift(newDatr);
      }
      this.insureder = insureder;
      console.log(this.insureder);
    },
    /** 判断保障权益是否存在*/
    // protectRight() {
    //   this.$http({
    //     url: "/policy/policyInterest/api/list",
    //     data: {
    //       policyId: this.orderId,
    //       asc: true,
    //       pageSize: "50",
    //     },
    //   })
    //     .then((data) => {
    //       if (data.data.length > 0) vm.interestHide = true;
    //     })
    //     .catch((err) => {});
    // },
  },
};
</script>

<style lang="scss" scoped>
.policyProp {
  .cell-title {
    font-size: 32px;
    line-height: 100px;
    padding: 0 30px;
    color: #000;
    font-weight: 700;
  }
  .bzInfo {
    height: 60vh;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .van-popup__close-icon {
    color: #3c464f;
    top: 25px;
    right: 25px;
    font-size: 42px;
  }
  .top {
    line-height: 100px;
    text-align: center;
    color: #000;
    font-size: 34px;
    font-weight: 700;
    border-bottom: 1px solid #e7eaec;
  }
  .van-cell__title {
    div {
      display: flex;
      justify-content: space-between;
    }
    .left {
      width: 60%;
    }
    .right {
      width: 39%;
      text-align: right;
      color: #377aff;
    }
  }
  .van-collapse-item__content {
    padding: 0 30px;
  }
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: "Microsoft YaHei";
    font-size: 28px;
    color: #555555;
    line-height: 46px;
    padding: 30px;
    background: #f8f8f9;
  }

  .popupBox {
    .popupDesc {
      font-size: 26px;
      padding: 30px;
      color: #888888;
      display: flex;
      align-items: center;
      .van-icon {
        font-size: 26px;
        color: #ff5715;
        margin-right: 10px;
        position: relative;
        top: -1px;
      }
    }
    /deep/.insurers {
        width: 100%;
        padding: 20px;
        height: 100px;
        background: #fff;
        .van-tabs__wrap {
          height: 100%;
        }
        .van-tabs__nav--line {
          padding-bottom: 0;
        }
        .van-tabs__line {
          display: none;
        }
        .van-tab {
          font-size: 30px;
          color: #377aff;
          border-radius: 8px;
          margin: 0 10px;
          background: #e3ecff;
          flex: none;
          box-sizing: border-box;
          span {
            color: #377aff;
          }
          &.van-tab--active {
            background: #377aff;
            span {
              color: #fff;
            }
          }
        }
      }
  }
}
.policyDate {
  min-height: 100vh;
  background-color: #f2f2f5;
  .policyStatus {
    position: relative;
    padding: r(29) r(40) r(25) r(136);
    min-height: r(130);
    background-image: radial-gradient(
      farthest-corner at 0% 5%,
      #ffa22b,
      #ff7c23
    );
    .icons {
      position: absolute;
      left: r(30);
      top: 50%;
      margin-top: -45px;
      font-size: 90px;
      color: #fff;
    }
    .name {
      font-size: r(32);
      line-height: r(45);
      color: #fff;
      font-weight: bold;
    }
    .text {
      font-size: r(24);
      line-height: r(33);
      // max-height:r(99);
      color: #fff;
    }
  }
  .listInfoBox {
    font-size: r(34);
    .order-detail {
      display: flex;
      div {
        flex: 0 0 523px;
        font-size: 24px;
        color: #3c464f;
        line-height: 34px;
        p {
          margin-top: 16px;
        }
        .title {
          font-size: 34px;
          font-weight: 700;
          color: #000000;
          line-height: 46px;
          margin-top: 0;
          padding-top: 30px;
          margin-bottom: 25px;
        }
        .btn-copy {
          padding: 2px 10px;
          border-radius: 2px;
          border: 1px solid #ff5715;
          font-size: 24px;
          color: #ff5715;
          line-height: 38px;
          margin-left: 10px;
        }
      }
      .status-logo {
        flex: 0 0 156px;
        width: 156px;
        height: 156px;
        margin-top: 18px;
      }
    }
    .pay-detail {
      padding: 0 40px 0 40px !important;
      .title {
        font-size: 28px;
        color: #3c464f;
        line-height: 42px;
        padding-top: 40px;
        // margin-bottom: 40px;
        /deep/span,
        .c-b {
          color: #236dff !important;
        }
      }
      .flex-end {
        display: flex;
        justify-content: flex-end;
        .btn-pay {
          margin: 40px 0;
          display: inline-block;
          width: 186px;
          height: 56px;
          background: #236dff;
          border-radius: 30px;
          font-size: 26px;
          color: #ffffff;
          line-height: 56px;
          text-align: center;
        }
      }
    }
    .p-t-40 {
      padding-top: 40px !important;
    }
    .fwBottom {
      background: #f8f8f9;
      padding: 35px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      // margin-top: 40px;
      .left a,
      .right a {
        padding: 0 48px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 30px;
        }
        span {
          font-size: 28px;
          color: #3c464f;
          margin-left: 4px;
        }
      }
      .left {
        border-right: 1px solid #dddddd;
        a span {
          color: #fd7945;
        }
      }
    }
    .policy-04-list {
      background-color: #fff;
      margin-bottom: r(20);
      padding: r(0) r(40) r(40) r(40);

      .dlBox {
        z-index: 3;
        .dlheader {
          position: relative;
          font-size: r(32);
          font-weight: bold;
          border-bottom: 1px solid #e7eaec;
          margin: 0 -40px 0;
          padding: 0 40px;
          height: 100px;
          line-height: 100px;
          display: flex;
          align-items: center;
          .item-title {
            flex: 1;
          }
          .c-o {
            font-size: 26px;
            color: #ff5715;
          }
          .company-logo {
            height: 70px;
          }
        }
        dd {
          position: relative;
          padding-top: r(30);
          box-sizing: border-box;
          .ulListBox {
            position: relative;
            z-index: 11;
            .c-b {
              color: #236dff;
            }
            li {
              line-height: 40px;
              position: relative;
              font-size: r(28);
              word-break: break-all;
              color: #000000;
              margin-bottom: r(20);
              display: flex;
              justify-content: space-between;
              &:last-child {
                margin-bottom: 0;
              }
              & span:first-child {
                color: #666666;
              }
              .btn {
                display: inline-block;
                text-align: center;
                border: 1px solid #ff6f07;
                background: #fff;
                color: #ff6f07;
                margin: 0 3px;
                border-radius: r(9);
                font-size: r(28);
                height: r(60);
                line-height: r(58);
                padding: 0 8px;
              }
            }
            .first-design-color {
              color: #377aff !important;
              font-weight: bold;
              span {
                color: #377aff !important;
              }
            }

            .lastList {
              margin: r(10) 0;
              padding-right: r(20);
              text-align: right;
              min-height: 0;
            }
          }
        }
      }
    }
  }
  .bottom-btns {
    position: fixed;
    z-index: 100;
    bottom: 0;
    left: 0;
    padding: 10px;
    width: 100%;
    background-color: #fff;
    border-top: 1px dashed #ddd;
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .btn {
      background-color: $personal-col;
      margin: 4px;
      height: 60px;
      line-height: 60px;
      padding: 0 20px;
    }
    .btn-disable {
      background-color: #bdbdbd;
    }
  }
  .checkPolicy_list_mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
  }

  .checkPolicy_list {
    width: r(680);
    background: #fff;
    position: fixed;
    top: 30%;
    left: 50%;
    margin-left: r(-340);
    text-align: center;
    color: #000;
    z-index: 101;

    .checkPolicy_list_title {
      font-size: r(35);
      font-weight: 900;
      line-height: r(90);
      border-bottom: 1px solid #ccc;
    }

    .checkPolicy_list_item {
      padding: 0 r(20);

      .item {
        line-height: r(90);
        border-bottom: 1px solid #ccc;

        &:nth-last-of-type(1) {
          border: none;
        }
      }
    }
  }
  .prompt {
    padding: 5px r(30);
    border-top: 1px dashed #ddd;
    .list-form {
      font-size: r(34);
      line-height: 1.8;
      text-align: center;
    }
    .left-yuan {
      position: relative;
      font-size: r(30);
      line-height: 50px;
      color: #000;
      padding-left: 20px;
      &::before {
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: $personal-col;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -2px;
      }
    }
  }
}
</style>
